import * as Yup from 'yup';
const SchemaCaptura = Yup.object({
    numero: Yup.number('No se permiten letras').required("El número es requerido.").min(1,"El número no debe ser menor de 0").max(999,"El número maximo no pude ser mayor de 1000").test('len', 'Se necesita minimo 2 valores', val => val.toString().length >1),
    cantidad: Yup.number('No se permiten letras').required("La cantidad es requerida."),
  });

  export default SchemaCaptura;